module.exports = __webpack_public_path__ + "static/media/backgroundweaving.7620f666.jpg";